export const SET_DATA_ANALYTICS = "SET_DATA_ANALYTICS";
export const SET_PROGRESS_ANALYTICS = "SET_PROGRESS_ANALYTICS";
export const SET_FILTER_ANALYTICS_CASHBOX = "SET_FILTER_ANALYTICS_CASHBOX";
